import {observer} from 'mobx-react';
import {Panel, AvatarList, CheckboxWithLabel} from 'shared/components';
import {ReviewRow} from 'main/components/flow';
import {t} from 'shared/core';

const Review = observer(({uiState}) => {
  const {match, schedule} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('time_tracking.manage.schedules.edit.Review your schedule')}
        description={t('time_tracking.manage.schedules.edit.Hover over a section and click edit to make changes.')}
      />
      <ReviewRow
        title='time_tracking.manage.schedules.edit.Schedule Name'
        value={schedule.name}
        editRoute={`/schedules/${match.params.id}/edit/schedule_details`}
      />
      <ReviewRow
        title='time_tracking.manage.schedules.edit.Managers'
        value={schedule.managers.map(manager => manager.name).join(', ')}
        editRoute={`/schedules/${match.params.id}/edit/schedule_details`}
      />
      <ReviewRow
        title='time_tracking.manage.schedules.edit.steps.Employees'
        editRoute={`/schedules/${match.params.id}/edit/employees`}
      >
        <AvatarList employees={schedule.employees} moreModalEnabled/>
      </ReviewRow>
      <ReviewRow title='time_tracking.manage.schedules.edit.Notifications' lastRow>
        <CheckboxWithLabel
          label='time_tracking.manage.schedules.edit.Notify employees when their shifts are published or changed'
          value={schedule.sendSchedulePublishedNotification}
          checked={schedule.sendSchedulePublishedNotification}
          onChange={e => schedule.merge({sendSchedulePublishedNotification: e.checked})}/>
      </ReviewRow>
    </div>
  );
});

export default Review;
